import React, { useCallback, useState } from "react";
// import "@shopify/polaris/build/esm/styles.css";
import {
  BrowserRouter,
  useRoutes, // instead of "Switch"
} from "react-router-dom";
import "./Assets/Styles/globals.css";
import "./Assets/Styles/react-tagsinput.css";
import Login from "./Pages/Authentication/Login";
import NavigationLayout from "./Components/NavigationLayout";
import Drivers from "./Pages/Drivers/List";
import AddEditDriver from "./Pages/Drivers/AddEdit";
import SupplierWarehouse from "./Pages/SupplierWarehouse/SupplierWarehouse";
import SupplierWarehouseDetails from "./Pages/SupplierWarehouse/SupplierWarehouseDetails";
import BulkOrderTransfer from "./Pages/BulkOrderTransfer/BulkOrderTransfer";
import BulkOrderTransferDetails from "./Pages/BulkOrderTransfer/BulkOrderTransferDetails";
import AddEditTask from "./Pages/BulkOrderTransfer/AddEditTask";
import SortingCenter from "./Pages/SortingCenter/SortingCenter";
import SortingCenterDetails from "./Pages/SortingCenter/SortingCenterDetails";
import WarehouseBeirut from "./Pages/WarehouseBeirut/WarehouseBeirut";
import WarehouseBeirutDetails from "./Pages/WarehouseBeirut/WarehouseBeirutDetails";
import Returns from "./Pages/Returns/Returns";
import ReturnDetails from "./Pages/Returns/ReturnDetails";
import BulkReturns from "./Pages/BulkReturns/BulkReturns";
import AddEditTaskBulkReturn from "./Pages/BulkReturns/AddEditTask";
import Closed from "./Pages/Closed/Closed";
import ClosedDetails from "./Pages/Closed/ClosedDetails";

function App() {
  if (process.env.NODE_ENV === "production") {
    console.log = function () {};
  }

  return useRoutes([
    {
      path: "/",
      element: <Login />,
    },

    {
      path: "/admin/drivers",
      element: (
        <NavigationLayout>
          <Drivers />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/drivers/new",
      element: (
        <NavigationLayout>
          <AddEditDriver type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/drivers/:id",
      element: (
        <NavigationLayout>
          <AddEditDriver type="edit" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/supplier-warehouse",
      element: (
        <NavigationLayout>
          <SupplierWarehouse />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/supplier-warehouse/:id",
      element: (
        <NavigationLayout>
          <SupplierWarehouseDetails />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/bulk-order-transfer",
      element: (
        <NavigationLayout>
          <BulkOrderTransfer />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/bulk-order-transfer/:id",
      element: (
        <NavigationLayout>
          <BulkOrderTransferDetails />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/bulk-order-transfer/tasks/new",
      element: (
        <NavigationLayout>
          <AddEditTask type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/bulk-order-transfer/tasks/:id",
      element: (
        <NavigationLayout>
          <AddEditTask type="edit" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/sorting-center",
      element: (
        <NavigationLayout>
          <SortingCenter />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/sorting-center/:id",
      element: (
        <NavigationLayout>
          <SortingCenterDetails />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/warehouse-beirut",
      element: (
        <NavigationLayout>
          <WarehouseBeirut />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/warehouse-beirut/:id",
      element: (
        <NavigationLayout>
          <WarehouseBeirutDetails />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/returns",
      element: (
        <NavigationLayout>
          <Returns />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/returns/:id",
      element: (
        <NavigationLayout>
          <ReturnDetails />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/bulk-returns",
      element: (
        <NavigationLayout>
          <BulkReturns />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/bulk-returns/:id",
      element: (
        <NavigationLayout>
          <BulkOrderTransferDetails />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/bulk-returns/tasks/new",
      element: (
        <NavigationLayout>
          <AddEditTaskBulkReturn type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/bulk-returns/tasks/:id",
      element: (
        <NavigationLayout>
          <AddEditTaskBulkReturn type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/closed",
      element: (
        <NavigationLayout>
          <Closed />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/closed/:id",
      element: (
        <NavigationLayout>
          <ClosedDetails />
        </NavigationLayout>
      ),
    },
  ]);
}
export default App;
